import { SortCode } from 'gql/autogen/SortCode';
import { SortOrder } from 'gql/autogen/SortOrder';
import { Matrix } from 'gql/autogen/Matrix';
import { FilterCode } from 'gql/autogen/FilterCode';

export interface ReviewSortData {
    code: SortCode;
    order: SortOrder;
    cmsId: number;
}

export enum ReviewSortEnum {
    MostRelevant = 'Default_Default',
    DateDescending = 'Date_Descending',
    RatingDescending = 'Rating_Descending',
    RatingAscending = 'Rating_Ascending',
}

export const reviewSortDisplayKeyList: ReviewSortEnum[] = [
    ReviewSortEnum.MostRelevant,
    ReviewSortEnum.DateDescending,
    ReviewSortEnum.RatingDescending,
    ReviewSortEnum.RatingAscending,
];

export interface ReviewSortState {
    code: SortCode;
    order: SortOrder;
    type: string;
}

export const ReviewSortDisplayItem: Record<ReviewSortEnum, ReviewSortData> = {
    [ReviewSortEnum.MostRelevant]: { code: SortCode.Default, order: SortOrder.Default, cmsId: 289338 },
    [ReviewSortEnum.DateDescending]: { code: SortCode.ReviewDateTime, order: SortOrder.Descending, cmsId: 102078 },
    [ReviewSortEnum.RatingDescending]: { code: SortCode.Rating, order: SortOrder.Descending, cmsId: 276591 },
    [ReviewSortEnum.RatingAscending]: { code: SortCode.Rating, order: SortOrder.Ascending, cmsId: 276592 },
};

export interface ReviewValueFilter {
    code: FilterCode;
    id: string;
    count: number;
    label: string;
    type: string;
}

export const mockSortFilterMatrix: Matrix = {
    sort: {
        availableCode: [SortCode.ReviewDateTime, SortCode.Rating],
        availableOrder: [SortOrder.Ascending, SortOrder.Descending],
    },
    filter: {
        rangeFilterMatrix: [],
        valueFilterMatrix: [
            {
                code: FilterCode.Rating,
                availableValue: [
                    { id: '1', count: 100 },
                    { id: '2', count: 200 },
                    { id: '3', count: 300 },
                    { id: '4', count: 400 },
                    { id: '5', count: 500 },
                ],
            },
            {
                availableValue: [
                    {
                        count: 1000,
                        id: 'False',
                    },
                    {
                        count: 20,
                        id: 'True',
                    },
                ],
                code: FilterCode.ReviewWithImage,
            },
        ],
    },
};
